import WidgetMetricDisplay from "@/components/common/WidgetMetricDisplay";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import React from "react";
import { CallMissedIcon } from "../../icons/CallMissedIcon";
import { WidgetTitle } from "@/components/widgets/WidgetTitle";

interface TotalMissedCallsData {
  value: number;
  comparisonPercentage?: number;
}

interface TotalMissedCallsWidgetProps {
  data: TotalMissedCallsData;
  icon?: React.ReactNode;
  loading?: boolean;
  error?: string;
  onClick?: (filters: { [key: string]: string[] }) => void;
}

const TotalMissedCallsWidget: React.FC<TotalMissedCallsWidgetProps> = ({ data, loading, onClick }) => {
  const canClick = onClick && data.value > 0;

  const handleClick = () => {
    if (canClick) {
      onClick({ callStatus: ["Missed"] });
    }
  };

  return (
    <div
      className={`w-full min-w-[200px] rounded-lg border flex flex-col bg-white dark:bg-[#0C3451] dark:text-white dark:border-[#0C3451] p-3 transition-colors ${canClick ? 'hover:bg-gray-50 dark:hover:bg-[#1a4a66] cursor-pointer' : ''}`}
      onClick={handleClick}
    >
    <div className="flex flex-row items-center justify-between">
      <WidgetTitle className="truncate">Total Missed Calls</WidgetTitle>
      <TooltipProvider>
        <Tooltip delayDuration={0}>
          <TooltipTrigger asChild>
            <span className="cursor-pointer">
              <CallMissedIcon className="h-4 w-4 text-primary dark:text-white" />
            </span>
          </TooltipTrigger>
          <TooltipContent side="top">
            <p className="max-w-xs text-xs">
              The total number of calls that were not handled by the agent within a given time.
            </p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
      <div>
        <WidgetMetricDisplay
          value={data.value}
          comparisonPercentage={data.comparisonPercentage}
          loading={loading}
          format="number"
          invertColors={true}
        />
      </div>
    </div>
  );
};

export default TotalMissedCallsWidget;
